import React from 'react';
import { Trash2 } from 'lucide-react';
import { rb, RBField, RBInput, RBAddButton, RBEmptyHint } from '../theme';
import { emptyEducation } from '../sectionShapes';

export default function EducationStep({ state, setState }) {
  const updateRow = (i, key, value) =>
    setState((s) => ({
      ...s,
      educations: s.educations.map((row, idx) => (idx === i ? { ...row, [key]: value } : row)),
    }));

  const addRow = () => setState((s) => ({ ...s, educations: [...s.educations, emptyEducation()] }));
  const removeRow = (i) =>
    setState((s) => ({ ...s, educations: s.educations.filter((_, idx) => idx !== i) }));

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-400">
        Add your highest qualification first — school, college, diploma or ITI.
      </p>

      {state.educations.length === 0 && <RBEmptyHint>No education added yet.</RBEmptyHint>}

      {state.educations.map((edu, i) => (
        <div key={i} className={`rounded-2xl p-4 space-y-3 ${rb.glassSoft}`}>
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold uppercase tracking-wide text-violet-300">Qualification {i + 1}</span>
            <button type="button" onClick={() => removeRow(i)} className="p-1.5 rounded-lg text-red-400 hover:bg-white/5" aria-label="Remove this qualification">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            <RBField label="Degree / Course *">
              <RBInput value={edu.degree} onChange={(e) => updateRow(i, 'degree', e.target.value)} placeholder="e.g. 12th Pass / B.Com / ITI Electrician" />
            </RBField>
            <RBField label="School / College *">
              <RBInput value={edu.institution} onChange={(e) => updateRow(i, 'institution', e.target.value)} placeholder="e.g. Delhi University" />
            </RBField>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <RBField label="Year of passing">
              <RBInput value={edu.year} onChange={(e) => updateRow(i, 'year', e.target.value)} placeholder="e.g. 2021" />
            </RBField>
            <RBField label="Marks / CGPA">
              <RBInput value={edu.score} onChange={(e) => updateRow(i, 'score', e.target.value)} placeholder="e.g. 72% (optional)" />
            </RBField>
          </div>
        </div>
      ))}

      <RBAddButton label="Add a qualification" onClick={addRow} />
    </div>
  );
}
